import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'

import {
  createPlaybookVersion,
  publishPlaybookVersion,
} from '@/reducers/playbooks/playbook.actions'
import { openModal, closeModal } from '@/reducers/ui/ui.redux'

import { BasicModal } from '@/components/layout/modals/BasicModal'
import { ModalActions } from '@/components/modals/ModalActions'
import { UpdatePlaybookForm } from '@/views/Scorecards/forms/UpdatePlaybookForm'
import { Button } from '@/components/buttons/Button'

import {
  getPlaybookButtonDisabledStatus,
  getPlaybookButtonText,
  checkPlaybookErrors,
} from '../playbook.helpers'

export const PlaybookSubmitButton = ({ numberOfBreakingScorecards }) => {
  const history = useHistory()
  const dispatch = useDispatch()
  const { section } = useParams()
  const {
    loading,
    playbook,
    playbook: { id: playbookId, active, current: isLatestPlaybookVersion, body },
    dirty,
  } = useSelector((state) => state.playbook)
  const { scorecardAssociations } = useSelector((state) => state.scorecards.data)
  const { currentlyOpenModalId } = useSelector((state) => state.ui)

  const readyToRestore = !isLatestPlaybookVersion
  const readyToSaveDraft = dirty
  const readyToPublish = !dirty && !active
  const saveIsDisabled = getPlaybookButtonDisabledStatus(
    readyToRestore,
    readyToSaveDraft,
    readyToPublish,
    loading.savePlaybook
  )
  const playbookError = checkPlaybookErrors(body)
  const playbookButtonText = getPlaybookButtonText(readyToRestore, readyToPublish)

  const handlePublish = () => {
    dispatch(publishPlaybookVersion(playbookId))
  }

  const handleClickSubmit = () => {
    if (readyToRestore) {
      return dispatch(createPlaybookVersion(playbook, history, section, readyToRestore))
    }

    if (readyToPublish) {
      const shouldTriggerConfirmModal =
        scorecardAssociations?.length > 0 && numberOfBreakingScorecards > 0

      if (shouldTriggerConfirmModal) {
        return dispatch(openModal('confirmPlaybookActivation'))
      }
      return handlePublish()
    }

    return dispatch(createPlaybookVersion(playbook, history, section, readyToRestore))
  }

  const handleModalSave = () => {
    handlePublish()
    dispatch(closeModal())
  }

  return (
    <>
      {currentlyOpenModalId === 'confirmPlaybookActivation' && (
        <BasicModal
          title="Publish Draft"
          size="small"
          scrolling
          onClose={() => {
            dispatch(closeModal())
          }}
          show
        >
          <UpdatePlaybookForm scorecards={scorecardAssociations} playbook={playbook} />
          <ModalActions
            onClose={() => {
              dispatch(closeModal())
            }}
            onSubmit={handleModalSave}
            buttonLabel="Publish Anyway"
          />
        </BasicModal>
      )}
      <Button
        className="no-wrap"
        data-testid="playbook-submit-button"
        success={readyToPublish}
        brand={readyToSaveDraft || readyToRestore}
        onClick={handleClickSubmit}
        disabled={saveIsDisabled || Boolean(playbookError)}
        disabledTooltip={playbookError}
      >
        {playbookButtonText}
      </Button>
    </>
  )
}
